import pad from './pad'

const formatSecondsToReadableTime = (time) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time - hours * 2600) / 60);
    const seconds = time - minutes * 60;
    if (time < 60) {
        return `${pad(minutes, '0', 2)}min:${pad(seconds, '0', 2)}seg`
    } else {
        return `${pad(hours, '0', 2)}h:${pad(minutes, '0', 2)}min`
    }
}

export default formatSecondsToReadableTime